import handlebars from "handlebars";
import { AppraisalAttachment, AuditLog, AuditTemplate, GetAppraisalModel } from "../../../../../all_Interfaces";
import documentTemplate from "../templates/documentTemplate";
import auditTemplate from "../templates/auditTemplate";

export const compileAuditLogTemplate = (
    AuditLoggs:AuditLog[],appraisalData:GetAppraisalModel
  ): string => {
    const compiledAuditLogTemplate = handlebars.compile(auditTemplate);
    const dayjs = require('dayjs');
// lastModifiedDate

    var loggs:AuditTemplate[] = [];

    const date = new Date(appraisalData.created);
    

    if(AuditLoggs.length != 0){
        AuditLoggs.forEach((data:AuditLog) => {
        var log = new AuditTemplate();
        log.comments = data.taskComments;
        log.createdBy = data.approverName;
        if(data.status === 'New'){
        log.date = dayjs(data.created, "MM/DD/YYYY, hh:mm:ss").format("MMM-DD-YYYY HH:mm:ss");
        }else{
        log.date = dayjs(data.created, "M/D/YYYY, h:mm:ss A").format("MMM-DD-YYYY HH:mm:ss");
        }
        log.status = data.status;
        loggs.push(log);
    })
    }
    // var newLog = new AuditTemplate();
    // newLog.date = dayjs(date.toLocaleString(), "M/D/YYYY, h:mm:ss A").format("MMM-DD-YYYY HH:mm:ss");
    // newLog.createdBy = appraisalData.createdBy;
    // newLog.status = "New";
    // newLog.comments = "";
    // loggs.push(newLog);

    const data = {
        log: [...loggs],
        empty: loggs.length == 0 ? 'true' : 'false',
    }

    console.log(data);

    return compiledAuditLogTemplate(data);
}